import React, { useContext, useMemo } from 'react'

import { OrderContext } from '@ui/contexts'
import css from 'styled-jsx/css'
import { DoInfoTracking } from './do-info-tracking'

type DoInfoProps = {
  tracking: Types.ParcelInfo
}

export const DoInfo: React.FC<DoInfoProps> = ({ tracking }) => {
  const { orderDetail } = useContext(OrderContext)

  return useMemo(() => {
    return (
      <div className="do-info">
        <style jsx>{doStyle}</style>
        {tracking.tracking_date && tracking.tracking_numbers && (
          <DoInfoTracking dataTracking={tracking} />
        )}
      </div>
    )
  }, [orderDetail.id])
}

const doStyle = css`
  .do-info {
    &__product {
      display: flex;
    }

    &__image {
      border: 1px solid var(--gray-3);
    }

    &__item {
      flex: 1;

      p {
        font-size: 12px;
        line-height: 24px;
        color: var(--indigo-7);

        .has-text-weight-semibold {
          color: var(--gray-8);
        }
      }
    }

    &__property:not(:last-child) {
      margin-right: 24px;
    }

    &:not(:last-child) {
      padding-bottom: 2rem;
      margin-bottom: 2rem;
      border-bottom: 2px dashed var(--indigo-3);
    }

    img {
      border: 1px solid var(--indigo-3);
      box-sizing: border-box;
      border-radius: var(--round-4);
    }
  }
`
